import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ResumeLock.css';

const ResumeLock = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try{
        const response = await fetch('https://portfolionv-production-4752.up.railway.app/api/check-password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ password: code }),
        });
        const data = await response.json();
        if (data.success) {
            sessionStorage.setItem('resume_authenticated', 'true');
            navigate('/resume');
        } else {
            setError('Invalid code. Please try again.');
            setCode('');
        }
    } catch (error) {
        setError('An error occurred. Please try again.');
    } finally {
        setIsLoading(false);
    }
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className="resume-lock-page">
      <div className="resume-lock-container">
        <div className="lock-header">
          <h1>🔒 Protected Resume</h1>
          <p>This resume is password protected. Please enter the access code from my attached file to continue.</p>
        </div>

        <form onSubmit={handleSubmit} className="lock-form">
          <div className="input-group">
            <label htmlFor="resume-code">Access Code:</label>
            <input
              type="password"
              id="resume-code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Enter access code"
              required
              disabled={isLoading}
              className={error ? 'error' : ''}
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-actions">
            <button 
              type="submit" 
              className="btn-unlock"
              disabled={isLoading || !code.trim()}
            >
              {isLoading ? 'Verifying...' : 'Access Resume'}
            </button>
            
            <button 
              type="button" 
              className="btn-back"
              onClick={handleBackToHome}
              disabled={isLoading}
            >
              Back to Portfolio
            </button>
          </div>
        </form>

        <div className="lock-footer">
          <p>Don't have the code? Contact me for access.</p>
          <a href="mailto:nxv200004@utdallas.edu" className="contact-link">
            📧 nxv200004@utdallas.edu
          </a>
        </div>
      </div>
    </div>
  );
};

export default ResumeLock;
